// extracted by mini-css-extract-plugin
export default {"root":"root--yiMjv","header":"header--MmtGt","actions":"actions--iLfAG","back":"back--XjHfg","editorContainer":"editorContainer--puyzE"};